import { useEffect } from 'react';
import { useReveal } from '../hooks/useReveal';

function Reveal({ children, className = '', delay = 0, as: Component = 'div' }) {
  const [ref, isVisible] = useReveal();

  useEffect(() => {
    if (isVisible) return;
    const timer = setTimeout(() => {
      if (ref.current) {
        ref.current.style.opacity = '1';
        ref.current.style.transform = 'translateY(0)';
      }
    }, 2000 + delay);
    return () => clearTimeout(timer);
  }, [isVisible, delay, ref]);

  return (
    <Component
      ref={ref}
      className={`transition-all duration-300 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Component>
  );
}

export default Reveal;
